import store from '../store';
import GeoClient from './GeoClient';

export default class OmClient {
  bearerToken;

  omBaseUrl;

  geoClient;

  constructor(bearerToken) {
    this.bearerToken = bearerToken;
    this.omBaseUrl = process.env.VUE_APP_OM_URL;
    this.geoClient = new GeoClient(bearerToken);
  }

  generateDefaultHeaders() {
    return {
      Accept: 'application/json',
      Authorization: `Bearer ${this.bearerToken}`,
    };
  }

  fetchOnlineIssuing(countryGeoId) {
    const requestUrl = `${this.omBaseUrl}/rest/1.0/onlineIssuing?countryGeoId=${countryGeoId}`;
    fetch(requestUrl, {
      method: 'GET',
      headers: this.generateDefaultHeaders(),
    }).then((response) => {
      response.json().then((data) => {
        if (data.items.length !== 0) {
          store.dispatch('setOnlineIssuing', data.items[0]);
        } else {
          store.dispatch('setOnlineIssuing', null);
        }
      });
    });
  }

  fetchPos(countryGeoId) {
    const requestUrl = `${this.omBaseUrl}/rest/1.0/pos?countryGeoId=${countryGeoId}`;
    fetch(requestUrl, {
      method: 'GET',
      headers: this.generateDefaultHeaders(),
    }).then((response) => {
      response.json().then((data) => {
        if (data.items.length !== 0) {
          store.dispatch('setPos', data.items);
          // Fetch cities for POS
          const cityGeoIds = [...new Set(data.items.map((record) => record.cityGeoId))];
          // XXX: This is not ideal we know it. But for this easy widget is acceptable.
          this.geoClient.fetchCities(cityGeoIds);
        } else {
          store.dispatch('setPos', null);
          store.dispatch('setLoading', false);
        }
      });
    });
  }
}
